// extracted by mini-css-extract-plugin
export default {"root":"NotificationIcon_root__4glW8"};